(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1909],{

/***/ 75340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_BreadcrumbLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/lib/addLocalePrefix.ts
var addLocalePrefix = __webpack_require__(57467);
// EXTERNAL MODULE: ./src/components/commons/menus/BreadcrumbListComponent.module.scss
var BreadcrumbListComponent_module = __webpack_require__(33238);
var BreadcrumbListComponent_module_default = /*#__PURE__*/__webpack_require__.n(BreadcrumbListComponent_module);
;// CONCATENATED MODULE: ./src/components/commons/menus/BreadcrumbListComponent.tsx





var BreadcrumbComponent = function(param) {
    var menus = param.menus;
    var locale = (0,router.useRouter)().locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: (BreadcrumbListComponent_module_default()).breadcrumb,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: (BreadcrumbListComponent_module_default()).breadcrumbItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: (0,addLocalePrefix/* addLocalePrefix */.Le)("/", locale),
                    legacyBehavior: true,
                    children: "ecbo cloak"
                })
            }),
            menus.map(function(menu, index) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                    className: (BreadcrumbListComponent_module_default()).breadcrumbItem,
                    children: menus.length === index + 1 || !menu.path || (menu === null || menu === void 0 ? void 0 : menu.path) === "" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: menu.label
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: (0,addLocalePrefix/* addLocalePrefix */.Le)(menu.path, locale),
                        children: menu.label
                    })
                }, index);
            })
        ]
    });
};
/* harmony default export */ var BreadcrumbListComponent = (BreadcrumbComponent);

// EXTERNAL MODULE: ./src/components/commons/layouts/BreadcrumbLayout.module.scss
var BreadcrumbLayout_module = __webpack_require__(97283);
var BreadcrumbLayout_module_default = /*#__PURE__*/__webpack_require__.n(BreadcrumbLayout_module);
;// CONCATENATED MODULE: ./src/components/commons/layouts/BreadcrumbLayout.tsx



var BreadcrumbLayout = function(param) {
    var menus = param.menus;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: (BreadcrumbLayout_module_default()).layout,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (BreadcrumbLayout_module_default()).layoutContainer,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbListComponent, {
                menus: menus
            })
        })
    });
};
/* harmony default export */ var layouts_BreadcrumbLayout = (BreadcrumbLayout);


/***/ }),

/***/ 63995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2248);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57467);
/* harmony import */ var _commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7419);
/* harmony import */ var _AreaPrefectureList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68082);
/* harmony import */ var _AreaPlaceList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18074);
/* harmony import */ var hooks_common_lang__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16529);
/* harmony import */ var _LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59175);
/* harmony import */ var _LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8__);








// hooks


var LocationSection = function(param) {
    var locations = param.locations, prefectures = param.prefectures, isSelectedArea = param.isSelectedArea, onSelectArea = param.onSelectArea, setIsSelectedArea = param.setIsSelectedArea, selectedPrefecture = param.selectedPrefecture, stations = param.stations, facilities = param.facilities, locale = param.locale, _countryCode = param.countryCode, countryCode = _countryCode === void 0 ? "jpn" : _countryCode, _isShowBackButton = param.isShowBackButton, isShowBackButton = _isShowBackButton === void 0 ? true : _isShowBackButton, _isShowAreaName = param.isShowAreaName, isShowAreaName = _isShowAreaName === void 0 ? true : _isShowAreaName, sectionTitle = param.sectionTitle, areaPlaceListHeadingStyle = param.areaPlaceListHeadingStyle, placeName = param.placeName;
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)().t;
    var getFieldName = function(locale, item, key) {
        var ref;
        return locale === "ja" ? item[key] : (ref = item["".concat(locale, "_").concat(key)]) !== null && ref !== void 0 ? ref : item[key];
    };
    var prefectureAreas = prefectures !== null && prefectures !== void 0 ? prefectures : [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_commons_layouts_SectionLayout__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        sectionName: "location",
        title: sectionTitle ? sectionTitle : t("TOP.LOCATION.TITLE"),
        titleStyle: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().title),
        children: isSelectedArea ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().selectedArea),
            children: [
                isShowBackButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().backList),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().btnBack),
                        onClick: function() {
                            return setIsSelectedArea(false);
                        },
                        type: "button",
                        children: t("TOP.LOCATION.BACK_BUTTON_TEXT")
                    })
                }),
                isShowAreaName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().areaName),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                        href: (0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_4__/* .addLocalePrefix */ .Le)("/jpn/city/".concat(selectedPrefecture.slug), locale),
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().areaNameLink),
                            children: t("TOP.LOCATION.PREFECTURE_AREA_LABEL", {
                                prefecture: getFieldName(locale, selectedPrefecture, "name")
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AreaPlaceList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    prefectureSlug: selectedPrefecture.slug,
                    places: stations,
                    label: placeName ? t("AREAS.CITY.SLUG.LOCATION_SECTION_TITLE_PLACE_STATION_PREFECTURE", {
                        place: placeName
                    }) : t("TOP.LOCATION.STATION_LABEL"),
                    countryCode: countryCode,
                    locale: locale,
                    headingStyle: areaPlaceListHeadingStyle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().stationsContent),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AreaPlaceList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        prefectureSlug: selectedPrefecture.slug,
                        places: facilities,
                        label: placeName ? t("AREAS.CITY.SLUG.LOCATION_SECTION_TITLE_PLACE_FACILITY_PREFECTURE", {
                            place: placeName
                        }) : t("TOP.LOCATION.FACILITY_LABEL"),
                        countryCode: countryCode,
                        locale: locale,
                        headingStyle: areaPlaceListHeadingStyle
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                (locations === null || locations === void 0 ? void 0 : locations.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().locationsItems),
                    children: locations.map(function(location, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().item),
                            style: {
                                background: location.backgroundImage,
                                backgroundSize: "cover"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().itemOverlay),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    href: (0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_4__/* .addLocalePrefix */ .Le)("/jpn/city/".concat(location.slug), locale),
                                    passHref: true,
                                    legacyBehavior: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().areaNameLink),
                                        children: location.name
                                    })
                                })
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().areaItems),
                    children: [
                        countryCode === "jpn" && prefectureAreas.length > 0 && prefectureAreas.map(function(prefecture, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().areaItem),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AreaPrefectureList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    areaName: (0,hooks_common_lang__WEBPACK_IMPORTED_MODULE_9__/* .getAreaName */ .kB)(locale, prefecture),
                                    prefectures: prefecture.prefectures,
                                    onSelectAreaName: onSelectArea,
                                    locale: locale,
                                    countryCode: countryCode
                                })
                            }, index);
                        }),
                        countryCode === "twn" && prefectureAreas.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().gridLocationContainer),
                            children: prefectureAreas.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().location),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().area),
                                            children: item.area_name
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().cityContainer),
                                            children: (item.prefectures || []).map(function(prefecture, index) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    onClick: function() {
                                                        return next_router__WEBPACK_IMPORTED_MODULE_3___default().push((0,lib_addLocalePrefix__WEBPACK_IMPORTED_MODULE_4__/* .addLocalePrefix */ .Le)("/twn/city/".concat(prefecture.slug), locale));
                                                    },
                                                    className: (_LocationSection_module_scss__WEBPACK_IMPORTED_MODULE_8___default().city),
                                                    children: prefecture.name
                                                }, index);
                                            })
                                        })
                                    ]
                                }, index);
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LocationSection);


/***/ }),

/***/ 57618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useFacilities; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10092);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var features_facility_services_facilitiesListApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5040);







var useFacilities = function() {
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().i18n;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), groupedFacilities = ref[0], setGroupedFacilities = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLoading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isError = ref2[0], setIsError = ref2[1];
    var fetchFacilities = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(prefectureId, options) {
            var data, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setIsError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,features_facility_services_facilitiesListApi__WEBPACK_IMPORTED_MODULE_2__/* .fetchFacilitiesByPrefecture */ .KQ)(prefectureId, i18n.language, options === null || options === void 0 ? void 0 : options.type)
                        ];
                    case 2:
                        data = _state.sent().data;
                        setGroupedFacilities(data);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setIsError(true);
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error) ? error : new Error(String(error)), {
                            tags: {
                                hook: "useFacilities"
                            },
                            extra: {
                                prefectureId: prefectureId,
                                locale: i18n.language,
                                type: options === null || options === void 0 ? void 0 : options.type
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(prefectureId, options) {
            return _ref.apply(this, arguments);
        };
    }(), [
        i18n.language
    ]);
    return {
        groupedFacilities: groupedFacilities,
        isLoading: isLoading,
        isError: isError,
        fetchFacilities: fetchFacilities
    };
};


/***/ }),

/***/ 56313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ useStations; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10092);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64487);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2248);
/* harmony import */ var features_facility_services_facilitiesListApi__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5040);







var useStations = function() {
    var i18n = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)().i18n;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]), stations = ref[0], setStations = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), slug = ref1[0], setSlug = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isLoading = ref2[0], setLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isError = ref3[0], setIsError = ref3[1];
    var fetchStations = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(prefectureId) {
            var data, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        setIsError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,features_facility_services_facilitiesListApi__WEBPACK_IMPORTED_MODULE_2__/* .getStations */ .Vd)(prefectureId, i18n.language)
                        ];
                    case 2:
                        data = _state.sent().data;
                        setStations(data.facilities);
                        setSlug(data.slug);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setIsError(true);
                        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_5__/* .captureException */ .Tb((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(error, Error) ? error : new Error(String(error)), {
                            tags: {
                                hook: "useStations"
                            },
                            extra: {
                                prefectureId: prefectureId,
                                locale: i18n.language
                            }
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(prefectureId) {
            return _ref.apply(this, arguments);
        };
    }(), [
        i18n.language
    ]);
    return {
        stations: stations,
        slug: slug,
        isLoading: isLoading,
        isError: isError,
        fetchStations: fetchStations
    };
};


/***/ }),

/***/ 5040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KQ": function() { return /* binding */ fetchFacilitiesByPrefecture; },
/* harmony export */   "Vd": function() { return /* binding */ getStations; }
/* harmony export */ });
/* unused harmony export getFacilities */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10092);
/* harmony import */ var lib_axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61969);




var API_FACILITIES = "/api/web/facilities";
var fetchFacilitiesByPrefecture = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(prefectureId, locale, type) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        lib_axios__WEBPACK_IMPORTED_MODULE_0__/* .ecboClient.get */ .ZK.get(API_FACILITIES, {
                            params: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                                prefecture_id: prefectureId
                            }, type !== undefined ? {
                                type: type
                            } : {}),
                            headers: {
                                "Accept-Language": (0,lib_axios__WEBPACK_IMPORTED_MODULE_0__/* .getHeaderLocale */ .hi)(locale)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        {
                            isOk: true,
                            data: response.data
                        }
                    ];
            }
        });
    });
    return function fetchFacilitiesByPrefecture(prefectureId, locale, type) {
        return _ref.apply(this, arguments);
    };
}();
var getStations = function(prefectureId, locale) {
    return fetchFacilitiesByPrefecture(prefectureId, locale, "station");
};
var getFacilities = function(prefectureId, locale) {
    return fetchFacilitiesByPrefecture(prefectureId, locale, "facility");
};


/***/ }),

/***/ 57519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ useGoogleMapLogger; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10092);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61969);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25617);
/* harmony import */ var state_ducks_user_selectors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83552);








var useGoogleMapLogger = function() {
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return (0,state_ducks_user_selectors__WEBPACK_IMPORTED_MODULE_3__/* .getUser */ .P)(state);
    });
    var requestLog = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(params) {
            var response, error, ref;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            lib_axios__WEBPACK_IMPORTED_MODULE_1__/* .spaceClient.post */ .UW.post("/api/app/v1/google_map_logs", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, params), {
                                user_id: user === null || user === void 0 ? void 0 : user.user_id
                            }))
                        ];
                    case 1:
                        response = _state.sent();
                        return [
                            2,
                            {
                                isOk: true,
                                data: response.data
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        return [
                            2,
                            {
                                isOk: false,
                                error: error === null || error === void 0 ? void 0 : (ref = error.response) === null || ref === void 0 ? void 0 : ref.data
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(params) {
            return _ref.apply(this, arguments);
        };
    }(), [
        user === null || user === void 0 ? void 0 : user.user_id
    ]);
    return {
        logGoogleMapUsage: requestLog
    };
};


/***/ }),

/***/ 64007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useAffiliateTracking; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var useAffiliateTracking = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var queryValue = router.query.a;
        var affiliateTagCode = typeof queryValue === "string" ? queryValue : undefined;
        if (affiliateTagCode) {
            var thirtyDays = 30 * 24 * 60 * 60;
            (0,nookies__WEBPACK_IMPORTED_MODULE_1__.setCookie)(null, "affiliate_tag", affiliateTagCode, {
                maxAge: thirtyDays,
                path: "/",
                secure:  true && window.location.protocol === "https:",
                sameSite: "lax"
            });
        }
    }, [
        router.query.a
    ]);
    var getAffiliateTagCode = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        var cookies = (0,nookies__WEBPACK_IMPORTED_MODULE_1__.parseCookies)();
        return cookies.affiliate_tag || null;
    }, []);
    return {
        getAffiliateTagCode: getAffiliateTagCode
    };
};


/***/ }),

/***/ 97283:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","layout":"BreadcrumbLayout_layout__5VrP7","layoutContainer":"BreadcrumbLayout_layoutContainer__QbZfL"};

/***/ }),

/***/ 33238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"displaySizeDesktopMax":"3000","displaySizeDesktopMin":"992","displaySizeTabletMax":"991","displaySizeTabletMin":"576","displaySizeMobileMax":"575","displaySizeMobileMin":"0","desktopMin":"992px","tabletMax":"991px","tabletMin":"576px","mobileMax":"575px","white1":"#fff","breadcrumb":"BreadcrumbListComponent_breadcrumb__GhGFx","breadcrumbItem":"BreadcrumbListComponent_breadcrumbItem__8xk4b"};

/***/ })

}]);